export interface AccordionData {
    id: string;
    icons: any;
    labels: AccordionLabel;
    listItems?: Array<AccordionListItem>;
}

export interface AccordionLabel {
    sectionTitle: string;
}

export interface AccordionListItem {
    id: string;
    name: string;
    icon?: string;
}

export interface AccordionEvent {
    type: string; // category | listItem | displayAll
    id: string;
    target?;
}

export const ACCORDION_EVENT = {
    CATEGORY: 'category',
    LIST_ITEM: 'listItem',
    DISPLAY_ALL: 'displayAll'
};
